import { currencies, Currency, CurrencySymbol } from '../../../Constants/currencies'

export const getCurrencySymbol = (currency?: Currency): CurrencySymbol => {
  if (!currency) throw new Error(`Undefined currency provided to getCurrencySymbol`)

  return currencies[currency]
}
